import { api, auth } from './auth';
import { idb, type SavedGame, type SavedRuleset } from './idb';

let running = false;

/** Push offline games/rulesets to the server and pull the user's rulesets down. */
export async function syncNow(): Promise<{ pushed: number; pulled: number } | null> {
  if (running || !auth.get().token || !navigator.onLine) return null;
  running = true;
  try {
    const rulesets = (await idb.all<SavedRuleset>('rulesets')).filter((r) => !r.synced);
    const games = (await idb.all<SavedGame>('games')).filter((g) => !g.synced && g.mode !== 'online');
    const res = await api<{ rulesets: SavedRuleset[] }>('/sync', { body: { rulesets, games } });
    for (const r of rulesets) await idb.put('rulesets', { ...r, synced: true });
    for (const g of games) await idb.put('games', { ...g, synced: true });
    const local = new Map((await idb.all<SavedRuleset>('rulesets')).map((r) => [r.id, r]));
    let pulled = 0;
    for (const r of res.rulesets) {
      const mine = local.get(r.id);
      if (!mine || mine.updatedAt < r.updatedAt) { await idb.put('rulesets', { ...r, synced: true }); pulled++; }
    }
    return { pushed: rulesets.length + games.length, pulled };
  } catch {
    return null;
  } finally {
    running = false;
  }
}

export function startAutoSync() {
  window.addEventListener('online', () => void syncNow());
  auth.subscribe(() => void syncNow());
  void syncNow();
  setInterval(() => void syncNow(), 60_000);
}
